import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const Intro = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1250);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-curtain"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-[#05070f]"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          initial={{ clipPath: "inset(0 0 0% 0)" }}
          transition={{ duration: 0.95, ease: [0.76, 0, 0.24, 1] }}
        >
          <svg viewBox="0 0 100 100" className="h-20 w-20">
            <defs>
              <linearGradient id="intro-z" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#2f6bff" />
                <stop offset=".5" stopColor="#22d3ee" />
                <stop offset="1" stopColor="#5cf2a0" />
              </linearGradient>
            </defs>
            <motion.path
              d="M30 29 H68 L32 71 H70"
              fill="none"
              stroke="url(#intro-z)"
              strokeWidth="12"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
            />
          </svg>
          <motion.span
            className="font-mono text-[11px] uppercase tracking-[0.4em] text-white/50"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            ZenVio — zenvio.dk
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
